module.exports = __webpack_public_path__ + "img/ccwl-3.af27297d.png";